import { assets } from '@/helpers/common'
import { domAnimation, LazyMotion, m } from 'framer-motion'

function BusinessStorageBanner() {
  return (
    <>
      <section className={'hidden xl:block with-banner white-ice-two'}>
        <div className='main-banner'>
          <div className='container-fluid mx-auto pt-24 pb-40 relative desktop-banner'>
            <div className='row justify-center'>
              <div className='w-1/5 text-center absolute left-0 bottom-0 scale-110 translate-x-4 translate-y-5'>
                <img src={assets('images/business-banner-01.png')} alt={''} />
              </div>
              <div className='w-3/5 text-center'>
                <LazyMotion features={domAnimation}>
                  <m.div
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    initial={{ scale: 0.8, y: 100, opacity: 0 }}
                  >
                    <div className='banner-content text-center'>
                      <h1 className='text-4xl2 font-bold text-secondary mb-4'>Business Storage Solution</h1>
                      <h2 className='text-2xl font-normal text-gray-400 mb-1'>
                        Do you need additional storage space for your growing business? Use our <br />
                        smart storage solution that is{' '}
                        <span className='font-bold text-secondary'>FREE up to 6 Months!</span>
                      </h2>
                    </div>
                  </m.div>
                </LazyMotion>
              </div>
              <div className='w-1/5 text-center absolute right-0 bottom-0 scale-110 -translate-x-5 translate-y-1'>
                <img src={assets('images/business-banner-02.png')} alt={''} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default BusinessStorageBanner
